<template>
  <div class="rescuer-directory" style="background-color: #fff6f2; min-height: 100vh;">
    <v-layout wrap align-center justify-space-between class="pa-5 pb-2">
      <v-flex>
        <h1 class="page-title mb-1" style="font-family: poppinssemibold; font-size: 24px; color: #1e293b; letter-spacing: 0.3px;">Rescuer <span style="color: #de520c;">Directory</span></h1>
      </v-flex>
    </v-layout>

    <div class="px-5 tabs-wrapper">
      <!-- Swipe hint: mobile only -->
      <div class="tab-count-hint" v-if="$vuetify.breakpoint.smAndDown">
        <v-icon size="13" color="#de520c">mdi-gesture-swipe-horizontal</v-icon>
        <span>Swipe to see all {{ tabs.length }} sections</span>
      </div>

      <v-tabs
        v-model="activeTab"
        background-color="transparent"
        color="#de520c"
        class="rescuer-tabs"
        show-arrows
        :center-active="false"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :key="tab.to"
          :to="tab.to"
          class="rescuer-tab"
        >
          <span class="tab-index-dot">{{ index + 1 }}</span>
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <!-- Progress dots -->
      <div class="tab-progress-bar">
        <div
          v-for="(tab, index) in tabs"
          :key="'dot-' + index"
          class="tab-dot"
          :class="{ 'tab-dot--active': isActiveTab(tab.to) }"
        ></div>
      </div>
    </div>

    <div class="directory-content pa-2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RescuerLayout',
  data() {
    return {
      activeTab: null,
      tabs: [
        { to: '/newrescuerslist',       label: 'New Requests' },
        { to: '/newrescuerslistcircle', label: 'New Requests (CI REC)' },
        { to: '/allrescuerlist',        label: 'Rescuer List' },
        { to: '/bannedRescuers',        label: 'Banned Rescuers' },
        { to: '/traininglist',          label: 'Training List' },
        { to: '/ratingsList',           label: 'Ratings Operations' },
      ]
    };
  },
  methods: {
    isActiveTab(path) {
      return this.$route.path === path;
    }
  }
}
</script>

<style scoped>
/* ─── Tab scroll wrapper ─────────────────────────────────────────── */
.tabs-wrapper {
  position: relative;
}

/* ─── Swipe hint (mobile only) ───────────────────────────────────── */
.tab-count-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: 'poppinsmedium', sans-serif;
  font-size: 11px;
  color: #de520c;
  margin-bottom: 6px;
  opacity: 0.85;
  letter-spacing: 0.2px;
}

/* ─── Tabs container ─────────────────────────────────────────────── */
.rescuer-tabs {
  border-bottom: 1px solid #e2e8f0;
}

/* Hide default scrollbar but keep scrollability */
.rescuer-tabs ::v-deep .v-slide-group__wrapper {
  overflow-x: auto !important;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.rescuer-tabs ::v-deep .v-slide-group__wrapper::-webkit-scrollbar {
  display: none;
}

/* Make arrow navigation visible on mobile */
.rescuer-tabs ::v-deep .v-slide-group__prev,
.rescuer-tabs ::v-deep .v-slide-group__next {
  min-width: 28px;
  color: #de520c !important;
}

/* ─── Individual tab ─────────────────────────────────────────────── */
.rescuer-tab {
  font-family: 'poppinsmedium', sans-serif !important;
  text-transform: none !important;
  font-size: 13.5px !important;
  letter-spacing: 0.2px !important;
  color: #64748b !important;
  margin-right: 4px;
  min-width: unset !important;
  padding: 0 14px !important;
  white-space: nowrap;
}

/* Numbered dot inside each tab */
.tab-index-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  font-size: 10px;
  font-family: 'poppinssemibold', sans-serif;
  background-color: #f1f5f9;
  color: #64748b;
  margin-right: 6px;
  flex-shrink: 0;
  transition: background-color 0.2s, color 0.2s;
}

.rescuer-tabs .v-tab--active {
  color: #de520c !important;
  font-weight: 600;
}

.rescuer-tabs .v-tab--active .tab-index-dot {
  background-color: #de520c;
  color: #ffffff;
}

/* Active underline slider */
.rescuer-tabs ::v-deep .v-tabs-slider {
  background-color: #de520c;
  height: 3px;
  border-radius: 3px 3px 0 0;
}

/* ─── Progress dots ──────────────────────────────────────────────── */
.tab-progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 7px 0 2px;
}

.tab-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #cbd5e1;
  transition: background-color 0.25s, transform 0.25s;
  flex-shrink: 0;
}

.tab-dot--active {
  background-color: #de520c;
  transform: scale(1.4);
}
</style>
